<template>
  <div class="job-card">
    <div
      class="jobs d-flex"
      style="justify-content: space-between;"
      @click="$emit('click', job)"
    >
      <div class="details-container">
        <div class="company-name">{{ company }}</div>
        <div class="job-title" v-html="highlightText(job.job_title, 'job_title')"></div>
      </div>
      <div v-if="isJobScouted" class="scouted-badge">
        <div class="scouted-badge-text">スカウト<br />希望済</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "JobListItem",
  props: {
    job: {
      type: Object,
      required: true,
    },
    index: {
      type: Number,
      required: true,
    },
    isJobScouted: {
      type: Boolean,
      required: true,
    },
    company: {
      type: String,
      required: true,
    },
    searchHighlights: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    highlightText(text, field) {
      // console.log(this.searchHighlights)
      if (!text || !this.searchHighlights.length) return text;
      
      const fieldHighlights = this.searchHighlights.find(h => h.path === field);
      if (!fieldHighlights) return text;

      let highlightedText = text;
      fieldHighlights.texts.forEach(({ value }) => {
        const regex = new RegExp(value, 'gi');
        highlightedText = highlightedText.replace(regex, match => `<span class="highlight">${match}</span>`);
      });
      
      return highlightedText;
    }
  }
};
</script>

<style scoped>
.job-card {
  background-color: white;
  border: 1px solid #e0e0e0;
  border-radius: 1px;
  padding: 16px;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  cursor: pointer;
}

.job-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.details-container {
  width: 285px; /* Default width for mobile */
}

.company-name {
  font-weight: bold;
  font-size: 16px;
  color: #3c3c3c;
  font-weight: 600;
  margin-bottom: 8px;
}

.job-title {
  font-size: 14px;
  font-weight: 600;
  color: #3c3c3c;
  word-wrap: break-word;
  white-space: normal;
}

.scouted-badge {
  margin: auto 0px;
}

.scouted-badge-text {
  width: 60px;
  border: 1px solid #f6ae2d;
  color: #f6ae2d;
  text-align: center;
  font-size: 10px;
}

.job-description {
  font-size: 12px;
  color: #666;
  margin-top: 4px;
  word-wrap: break-word;
  white-space: normal;
}

>>> .highlight {
  background-color: #ffd700;
  padding: 0 2px;
  border-radius: 2px;
}

@media (min-width: 1024px) {
  .details-container {
    width: 700px;
  }
}
</style>
